import 'css-chunksrc/components/icons/StatusIcon.module.scss';export default {
  "icon_skin": "StatusIcon_icon_skin",
  "has_background": "StatusIcon_has_background",
  "color_stationary": "StatusIcon_color_stationary",
  "color_success": "StatusIcon_color_success",
  "color_info": "StatusIcon_color_info",
  "color_error": "StatusIcon_color_error",
  "color_warning": "StatusIcon_color_warning",
  "has_border": "StatusIcon_has_border",
  "size_xs": "StatusIcon_size_xs",
  "size_sm": "StatusIcon_size_sm",
  "size_md": "StatusIcon_size_md",
  "size_lg": "StatusIcon_size_lg",
  "size_xl": "StatusIcon_size_xl"
};